import { createElement } from 'react';
import PropTypes from 'prop-types';

const P = ({ className, useBareClass, children, ...props }) =>
  createElement(
    'p',
    {
      ...props,
      className: useBareClass ? className : `body-4 ${className}`
    },
    children
  );

P.defaultProps = {
  className: '',
  useBareClass: false
};

P.propTypes = {
  className: PropTypes.string,
  useBareClass: PropTypes.bool,
  children: PropTypes.any.isRequired
};

export default P;
